document.addEventListener("DOMContentLoaded", function (event) {

    // GLS
    const el = document.getElementById('gls-map');

    if (el) {
        el.addEventListener('change', (e) => {
            Livewire.emit('parcelSelected', {
                id: e.detail.id,
                parcel_name: e.detail.name,
                zip: e.detail.contact.postalCode,
                city: e.detail.contact.city,
                street_house: e.detail.contact.address,
            })
        });

        Livewire.on('openGlsMap', () => {
            console.log('openGlsMap')
            el.showModal();
        })
    }

    // FOXPOST
    function receiveMessage(event) {
        if (event.origin !== 'https://cdn.foxpost.hu') return;

        const parcel = JSON.parse(event.data);

        Livewire.emit('parcelSelected', {
            id: parcel.operator_id,
            parcel_name: parcel.name,
            zip: parcel.zip,
            city: parcel.city,
            street_house: parcel.street
        })

        document.getElementById('foxpostModalClose').click();
    }

    window.addEventListener('message', receiveMessage, false);
});
